<template>
  <modal class="modalCG withSlider" @before-open="iphoneModalsSet" @before-close="closingModal" name="modalProduct"
         height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box" v-if="!product">

    </div>
    <div class="modal-box" v-if="product">
      <div class="modal-body relative p-0">
        <span class="cat-label"><icon name="sliders"
                                      class="icon rotate-90"></icon><span> {{ product.category.name }} </span></span>
        <div class="close" @click.prevent="close()">
          <icon name="close" scale="2"></icon>
        </div>
        <product-images-slider :product="product"></product-images-slider>
      </div>
      <div class="modal-body mt-6">
        <div class="flex sm:flex-row sm:flex-wrap mb-6">
          <div class="modal-body-left lg:w-1/3 md:w-1/3 sm:w-full pb-1x">
            <div class="text">
              <h3>{{ product.name }}</h3>
              <p class="font-size-15-lh25">von <span class="vendor-name">{{ product.shop.name }}</span></p>
              <p><span class="price">{{ formatPrice(product, 'unit') }}</span> <span
                  class="font-size-15-lh25 whitespace-no-wrap">pro {{ getTextFromUnit(product.unit) }}</span></p>
            </div>
          </div>
          <div class="modal-body-right lg:w-2/3 md:w-2/3 sm:w-full px-5 sm:px-0">
            <p class="font-size-15-lh25">{{ product.description }}</p>
          </div>
        </div>
        <div class="flex mb-6">
          <div class="w-1/3 sm:hidden"></div>
          <div class="w-2/3 sm:w-full pl-5 sm:px-0">
            <button class="btn icon outline green mr-1x lg:mb-1x" @click.prevent="buyLive(product.shop)"
                    v-if="product.shop.is_online">
              <span><icon class="icon" name="shopping-cart"></icon></span>
              <span>Jetzt live einkaufen</span>
            </button>
            <button @click.prevent="addToCart(product)" class="btn icon black outline">
              <span><icon class="icon" name="shopping-cart"></icon></span>
              <span>In den Warenkorb</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="false" class="modal-body bottom-body bg-cg-grey-middle">
        <div class="flex sm:flex-row sm:flex-wrap">
          <div class="lg:w-1/3 md:w-1/3 sm:w-full sm:pb-1x">
            <div class="font-size-15-lh25 pt-3">Produkt-eigenschaften:</div>
          </div>
          <div class="lg:w-2/3 md:w-2/3 sm:w-full font-size-15-lh25 pl-5 sm:px-0">
            <div class="property inline-block bg-cg-grey-property">Glutenfrei</div>
            <div class="property inline-block bg-cg-grey-property">Vegan</div>
            <div class="property inline-block bg-cg-grey-property">Vegetarisch</div>
            <div class="property inline-block bg-cg-grey-property">BIO</div>
            <div class="property inline-block bg-cg-grey-property">Ökologische Anbau/Aufzucht</div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import ProductImagesSlider from '../slider/productImagesSlider'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    components: {ProductImagesSlider},
    name: 'ProductModal',
    mounted () {
      EventBus.$on('toggleProductModal', () => {
        this.toggleModal()
      })
      EventBus.$on('escKey', () => {
        this.close()
      })
    },
    beforeDestroy () {
      EventBus.$off('escKey')
    },
    mixins: [helpers, formatting],
    props: {
      buyLiveToast: null
    },
    data () {
      return {
        show: false
      }
    },
    methods: {
      ...mapActions([
        'getInLine'
      ]),
      toggleModal () {
        console.log(this.show)
        this.show = !this.show
        this.show ? this.$modal.show('modalProduct') : this.$modal.hide('modalProduct')
      },
      closingModal () {
        this.show = false
        this.iphoneModalsUnset()
      },
      buyLive (shop) {
        if (this.isAuthenticated) {
          var self = this
          if (!this.buyLiveToast) {
            this.buyLiveToast = this.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              icon: 'info'
            })
            this.getInLine({
              shop: shop.uid,
              cb () {
                self.$toasted.success('Du stehst jetzt bei ' + shop.name, {
                  theme: 'primary',
                  position: 'top-right',
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              },
              errorCb () {
                self.$toasted.error('Ein Fehler ist aufgetreten, bitte versuche es nochmal oder kontaktiere unser Team', {
                  theme: 'primary',
                  position: 'top-right',
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              }
            })
          }
        } else {
          EventBus.$emit('toggleLoginModal')
        }
      },
      close () {
        this.show = false
        this.$modal.hide('modalProduct')
      },
      addToCart (product) {
        EventBus.$emit('toggleAddItemToCartModal', product)
      }
    },
    computed: {
      ...mapGetters({
        product: 'product_get_selected_product',
        isAuthenticated: 'auth_is_authenticated'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/Product.vue